<template>
  <div class="index-page">
    <div class="banner">
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <div class="banner-item banner-1">
            <div class="banner-text">
              <h2>专业医疗服务</h2>
              <p>为您的健康保驾护航</p>
            </div>
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="banner-item banner-2">
            <div class="banner-text">
              <h2>便捷预约挂号</h2>
              <p>足不出户轻松预约</p>
            </div>
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="banner-item banner-3">
            <div class="banner-text">
              <h2>资深专家团队</h2>
              <p>专业医生坐诊服务</p>
            </div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="clinic-info">
      <div class="info-header">
        <van-icon name="info-o" color="#3e97c1" size="20" />
        <span>诊所简介</span>
      </div>
      <div class="info-content">
        <p>本诊所成立于2010年，是一家集医疗、预防、保健为一体的综合性医疗机构。诊所拥有一支经验丰富、技术精湛的医疗团队，配备先进的医疗设备，致力于为患者提供优质、便捷的医疗服务。</p>
        <p>我们秉承"以患者为中心"的服务理念，坚持诚信行医、规范诊疗，努力打造让患者信赖的医疗服务品牌。</p>
      </div>
    </div>

    <div class="features">
      <van-grid :column-num="3" :border="false">
        <van-grid-item icon="friends-o" text="专业团队" />
        <van-grid-item icon="clock-o" text="便捷预约" />
        <van-grid-item icon="shield-o" text="安全保障" />
      </van-grid>
    </div>

    <div class="notice-section">
      <div class="section-header">
        <van-icon name="bell" color="#ff976a" size="18" />
        <span>预约须知</span>
      </div>
      <div class="notice-list">
        <div class="notice-item">
          <span class="notice-num">1</span>
          <span class="notice-text">预约成功后请按时就诊，如需取消请提前在"我的预约"中操作</span>
        </div>
        <div class="notice-item">
          <span class="notice-num">2</span>
          <span class="notice-text">就诊当天请携带有效身份证件，提前10分钟到达诊所</span>
        </div>
        <div class="notice-item">
          <span class="notice-num">3</span>
          <span class="notice-text">如遇医生临时停诊，我们会通过微信通知您，请注意查收</span>
        </div>
        <div class="notice-item">
          <span class="notice-num">4</span>
          <span class="notice-text">预约时间段为参考时间，实际就诊顺序以现场排队为准</span>
        </div>
      </div>
    </div>

    <div class="contact-section">
      <div class="section-header">
        <van-icon name="phone-o" color="#3e97c1" size="18" />
        <span>联系我们</span>
      </div>
      <van-cell-group>
        <van-cell title="诊所地址" value="XX市XX区XX路XX号" icon="location-o" />
        <van-cell title="联系电话" value="400-XXX-XXXX" icon="phone-o" />
        <van-cell title="营业时间" value="周一至周日 8:00-18:00" icon="clock-o" />
      </van-cell-group>
    </div>

    <div style="height: 70px;"></div>
    <van-tabbar v-model="active" @change="onChange">
      <van-tabbar-item icon="home-o" to="/index/index">首页</van-tabbar-item>
      <van-tabbar-item icon="calendar-o" to="/yuyue/index">预约</van-tabbar-item>
      <van-tabbar-item icon="user-o" to="/mine/index">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'IndexPage',
  data() {
    return {
      active: 0
    }
  },
  methods: {
    onChange(index) {
      console.log('切换到索引：', index)
    }
  }
}
</script>

<style scoped>
.index-page {
  background: #f5f5f5;
  min-height: 100vh;
}
.van-tabbar-item--active {
  color: #3e97c1;
}
.banner {
  height: 200px;
}
.banner-item {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center;
}
.banner-1 {
  background: linear-gradient(135deg, #3e97c1, #2d7eb0);
}
.banner-2 {
  background: linear-gradient(135deg, #07c160, #06ad56);
}
.banner-3 {
  background: linear-gradient(135deg, #ff976a, #ff6a4d);
}
.banner-text {
  text-align: center;
  color: #fff;
}
.banner-text h2 {
  font-size: 24px;
  margin-bottom: 10px;
}
.banner-text p {
  font-size: 14px;
  opacity: 0.9;
}
.clinic-info {
  background: #fff;
  margin: 10px;
  border-radius: 8px;
  padding: 15px;
}
.info-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.info-header .van-icon {
  margin-right: 8px;
}
.info-content {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
}
.info-content p {
  margin: 0 0 10px 0;
}
.info-content p:last-child {
  margin-bottom: 0;
}
.features {
  background: #fff;
  margin: 10px;
  border-radius: 8px;
  overflow: hidden;
}
.notice-section {
  background: #fff;
  margin: 10px;
  border-radius: 8px;
  padding: 15px;
}
.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.section-header .van-icon {
  margin-right: 8px;
}
.notice-list {
  padding-left: 5px;
}
.notice-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}
.notice-item:last-child {
  margin-bottom: 0;
}
.notice-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: #3e97c1;
  color: #fff;
  border-radius: 50%;
  font-size: 12px;
  margin-right: 10px;
  flex-shrink: 0;
}
.notice-text {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}
.contact-section {
  background: #fff;
  margin: 10px;
  border-radius: 8px;
  overflow: hidden;
}
.contact-section .section-header {
  padding: 15px 15px 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue